export default "/images/76b5f5a9751281c0dcb1d61b87935090.avif";